export function mapRange(
  [input_min, input_max],
  [output_min, output_max],
  value
) {
  return (
    output_min +
    (output_max - output_min) * ((value - input_min) / (input_max - input_min))
  );
}
